import './layout.scss'
import React from 'react'
import PropTypes from 'prop-types'
import Header from './header'
import Footer from './footer'

const Layout: React.FC = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Layout
